import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { trace } from '@opentelemetry/api';
// import { v4 as uuid } from 'uuid';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './authentication/auth.service';
import { tracer } from '../../../instrument';
import { ActivatedRoute, Router } from '@angular/router';
import { Span, SpanExporter } from '@opentelemetry/sdk-trace-web';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
 providedIn: 'root',
})
export class OpentelemetryService {
 http = inject(HttpClient);
 route = inject(ActivatedRoute);
 router = inject(Router);
 //  uuid: string = uuid();
 private _activeSpan!: Span;
 platformId = inject(PLATFORM_ID);

 defaultAttributes = {
  // 'http.method': this.route.snapshot.data['method'],
  // 'http.url': this.route.snapshot.data['url'],
  //   'route.path': isPlatformBrowser(this.platformId) ? location.href : '',
  //   'route.origin': isPlatformBrowser(this.platformId) ? location.origin : '',
  //   'user.cuid': this.authService.getCookie('cuid') ?? '',
  //   'user.luid': !this.authService._isAuthenticated() ? this.uuid : '',
  //   'user.email': this.userProfile?.email ?? '',
  //   'user.phone': this.userProfile?.phone ?? '',
  //   'user.name': this.userProfile?.firstName ?? '' + this.userProfile?.lastName ?? '',
 };

 sendEvent(event: string, attributes?: any) {
  console.log(event, attributes);

  this.activeSpan().addEvent(event, attributes);
  //   this.activeSpan().seta({
  //    ...this.defaultAttributes,
  //    ...attributes,
  //   });
 }

 startSpan(spanName: string) {
  const span = tracer.startSpan(spanName);
  this._activeSpan = span as Span;
 }

 activeSpan(): Span {
  return this._activeSpan as Span;
 }

 endSpan() {
  this.activeSpan().end();
 }
}
